import { useEffect } from "react";
import { supabase } from '../supabaseClient';
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/UserContext'; // Import useUser from UserContext

const AuthComponent = () => {
//   return (
//     <Auth
//         supabaseClient={supabase}
//         appearance={{ theme: ThemeSupa }}
//         providers={["google"]}
//         onlyThirdPartyProviders
//     />
//   );

    const { user } = useAuth(); // Access user and setUser from context
    const navigate = useNavigate();
    // const [session, setSession] = useState(null);

    useEffect(() => {
        if (user) {
        navigate('/dashboard');
        }
    }, [user, navigate]);

    // useEffect(() => {

    //     supabase.auth.getSession().then(({ data: { session } }) => {
    //         setSession(session);
    //         // setUser(session.user)
    //         // console.log(session)
    //     });

    //     const {
    //         data: { subscription },
    //     } = supabase.auth.onAuthStateChange((_event, session) => {
    //         setSession(session);
    //         // setUser(session.user)
    //         // console.log(session)
    //     });

    //     return () => subscription.unsubscribe();

    // }, []);

    if (!user) {
        return (
            <div className="quiz_app_login_header">
                 <h2  className="text-primary">Welcome to <span className="text-black">Quiz Maker AI</span></h2>
                 <p>Login/Sign up using the button below.</p>
                    <Auth
                        supabaseClient={supabase}
                        appearance={{ theme: ThemeSupa }}
                        // theme="default"
                        providers={["google"]}
                        //   view="sign_in"
                        //   showLinks={false}
                        onlyThirdPartyProviders
                    /> 

            </div>
        );
    } else {
        return (
            <div>
                <div>Logged in!</div>
                <button onClick={() => supabase.auth.signOut()}>Sign out</button>
            </div>
        );
    }

};

export default AuthComponent;
